import React, { useState, useRef } from "react"
import keyBy from "lodash.keyby"
import { useOutletContext } from "react-router-dom"

import { UpdateModal } from "@components/Page"
import { MODAL_WIDTH } from "@components/constants"
import { getFormSchema } from "@components/Form"
import { useAppContext } from "@components/AppContext"

import getInputs from "../ProjectPropertyCreateModal/helpers/getInputs"

const readOperation = "backstage/ReadProperty"
const updateOperation = "backstage/UpdateProperty"

const indexOperation = "backstage/IndexProperties"

const getUpdateSchema = getFormSchema(updateOperation)

const LABEL_ENTITY = "Property"
const LABEL_UPDATE = `Edit ${LABEL_ENTITY}`
const LABEL_SUBMIT = "Save"


const PropertyUpdateModal = ({ table, updateModal }) => {
  const modal = useRef({})
  const [ prevProjectId, setPrevProjectId ] = useState()
  const { projects, readProject, readConnectedFundProjects } = useOutletContext()
  const { request } = useAppContext()

  const [ updateSchema, setUpdateSchema ] = useState([])

  updateModal.current.open = async (id, projectId) => {
    const projectsMap = keyBy(projects, "id")
    const project = projectsMap[projectId]

    const { data: properties } = await request(indexOperation)

    setPrevProjectId(project?.id)

    const getUpdateInputs = getInputs({
      project,
      projects,
      properties,
    })
    const inputs = getUpdateInputs()
    const schema = getUpdateSchema(inputs)
    setUpdateSchema(schema)

    modal.current.open(id)
  }

  const onSuccess = updatedProperty => {
    const { id: propertyId, projectId } = updatedProperty
    const hasProjectChanged = prevProjectId !== projectId

    if (prevProjectId) {
      readProject(prevProjectId)
    }

    if (hasProjectChanged) {
      readProject(projectId)
    }

    readConnectedFundProjects(propertyId)
  }

  return (
    <UpdateModal
      table={table}
      modal={modal}
      title={LABEL_UPDATE}
      width={MODAL_WIDTH * 1.25}
      schema={updateSchema}
      entity={LABEL_ENTITY}
      onSuccess={onSuccess}
      operation={updateOperation}
      submitLabel={LABEL_SUBMIT}
      readOperation={readOperation}
    />
  )
}

export default PropertyUpdateModal
